import axios from "axios";
import qs from 'qs';

import userAxios from './_defaults/api';

export async function getPutUrl({activityId, file, params}) {
    try {
        const response = await userAxios.post(`/images/${activityId}`, {
            contentType: file.type,
            extension: file.name?.split(".").pop(),
        }, {params});
        return response?.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export async function uploadImage({activityId, file, params}) {

    try {

        const { url, key } = await getPutUrl({activityId, file, params})

        const headers = qs.parse(url?.split("?")[1]) || {};

        await axios.put(url, file, {
            headers: {
                "Cache-Control": headers["Cache-Control"],
                "Content-Type": headers["Content-Type"],
            },
        });

        return { url, key };

    } catch(error) {
        console.log("error uploading image:");
        console.log(error);
        throw error;
    }


}